<script setup lang="ts">
import { ButtonColor, ButtonSize, ButtonVariant } from '@/hooks/useButtonClasses';

import { useAiChat } from '@/domains/student-app/composables/useAiChat';
import { useChatBot } from '@/domains/chat/composables/useChatBot';

import AiAdviserDialog from './AiAdviserDialog.vue';
import Button from '@/components/button/Button.vue';
import IconButton from '@/components/button/IconButton.vue';

import AdviserSolid from '@/icons/solid/adviser.svg';

defineProps<{
  message?: string;
  label?: string;
  isStacked?: boolean;
}>();

const { openChatDialog } = useAiChat();

const { chatBotName, enableChatBotForStudents } = useChatBot();
</script>

<template>
  <div v-if="enableChatBotForStudents">
    <Button
      v-if="label"
      :color="ButtonColor.slate"
      :iconLeft="AdviserSolid"
      :size="ButtonSize.md"
      :variant="ButtonVariant.outlined"
      @click="openChatDialog(message)"
    >
      {{ label }}
    </Button>
    <template v-else>
      <IconButton
        :ariaLabel="`Chat with ${chatBotName}`"
        :color="ButtonColor.slate"
        :icon="AdviserSolid"
        :size="ButtonSize.md"
        :variant="ButtonVariant.invisible"
        class="hidden md:block"
        @click="openChatDialog(message)"
      />
      <IconButton
        :ariaLabel="`Chat with ${chatBotName}`"
        :color="ButtonColor.slate"
        :icon="AdviserSolid"
        :size="ButtonSize.lg"
        :variant="ButtonVariant.invisible"
        class="block md:hidden"
        @click="openChatDialog(message)"
      />
    </template>
    <AiAdviserDialog :isStacked="isStacked" />
  </div>
</template>
